
// Function to fetch OSM data from Overpass API
export const fetchOSMData = async (lat, lng, radius = 1.0) => {
  const query = `
    [out:json][timeout:60];
    (
      node(around:${radius * 1000}, ${lat}, ${lng});
      way(around:${radius * 1000}, ${lat}, ${lng});
      relation(around:${radius * 1000}, ${lat}, ${lng});
    );
    out body;
    >;
    out skel qt;
  `;

  const url = "https://www.overpass-api.de/api/interpreter";

  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: new URLSearchParams({ data: query })
    });

    if (response.ok) {
      const data = await response.json();
      console.log("Success! Data received from Overpass API.");
      return data;
    } else {
      console.error(`Error: Received status code ${response.status}`);
      return null;
    }
  } catch (error) {
    console.error("Error fetching data from Overpass API:", error);
    return null;
  }
};

// Function to filter OSM data based on tags
export const filterOSMData = (osmData, filterTags) => {
  const filteredData = [];

  osmData.elements.forEach((element) => {
    if (element.tags && element.type === 'way') {
      const tags = element.tags;
      const matchesFilter = Object.entries(filterTags).every(
        ([key, value]) => tags[key] === value
      );

      if (matchesFilter) {
        filteredData.push(element);
      }
    }
  });

  return filteredData;
};

